import {
  alias,
  shape as shapeType,
  number as numberType,
  useLazyDataModel,
  customType,
  string as stringType,
  arrayOf
} from '@thd-nucleus/data-sources';

const BigDecimal = numberType();
const String = stringType();

const CartAttr = shapeType({
  reCaptcha: String
});

const GiftCard = shapeType({
  cardNumber: String,
  pinNumber: String
});

const BalanceCheckBody = shapeType({
  cardNumber: String,
  availableAmount: BigDecimal,
  holdAmount: BigDecimal,
  originalAmount: BigDecimal,
  reloadableAmount: BigDecimal
});

const BalanceCheck = shapeType({
  cartAttr: CartAttr,
  giftCard: [GiftCard]
});

const experienceType = shapeType({
  type: String
});

const RequestContext = shapeType({
  tmxProfileId: String,
  experience: experienceType
});

const balanceCheck = BalanceCheckBody;
const balanceCheckRequest = customType('BalanceCheckRequest').shape(BalanceCheck);
const requestContext = customType('RequestContext').shape(RequestContext);

const getBalanceCheckQueryAndResponse = {
  balanceCheck: alias('balanceCheck')
    .params({ balanceCheck: balanceCheckRequest, requestContext })
    .shape({ balanceDetails: balanceCheck })
};

const SavedGiftCard = shapeType({
  savedPaymentId: String
});

const BulkBalanceCheck = shapeType({
  giftCard: [SavedGiftCard]
});

const bulkBalanceCheckRequest = customType('BalanceCheckRequest').shape(BulkBalanceCheck);
const bulkBalanceCheckRequestContext = customType('RequestContext').shape(RequestContext);
const bulkBalanceCheck = arrayOf(
  shapeType({
    savedPaymentId: String,
    availableAmount: BigDecimal
  })
);

const getBulkBalanceCheckQueryAndResponse = {
  balanceCheck: alias('balanceCheck')
    .params({
      balanceCheck: bulkBalanceCheckRequest,
      requestContext: bulkBalanceCheckRequestContext
    })
    .shape({ balanceDetails: bulkBalanceCheck })
};

const useGiftcardBalanceCheck = (props) => {
  // remaining variables are provided when lazy function is triggered
  const [checkBalance, { data, error, loading }] = useLazyDataModel('balanceCheck', {
    ssr: false,
    dataModel: props?.isBulk
      ? getBulkBalanceCheckQueryAndResponse
      : getBalanceCheckQueryAndResponse,
    fetchPolicy: 'no-cache'
  });

  const gcCheckBalanceResponse = (params) => {
    checkBalance(params);
  };
  return [gcCheckBalanceResponse, { data, error, loading }];
};

export { useGiftcardBalanceCheck };
